var app = angular.module("leonardo");

var MessagesController = function($scope, $state, MessageService) {
  $scope.messages = [];
  $scope.close = function() {
    $scope.messages = [];
  };

  $scope.goToMessage = function (message) {
    if (message.type == 'expired documents') {
      $state.go('documents.expired');
    }
  };
};

app.controller('MessagesController', ['$scope', '$state', 'MessageService', MessagesController]);
